import { gameConfig } from '../config'
import { Container } from '@pixi/react'
import { BalanceContainer } from './BalanceContainer'
import { StakeContainer } from './StakeContainer'

interface NumberDisplayProps {
  x: number
  y: number
}
export const NumberDisplay = (props: NumberDisplayProps) => {
  return (
    <Container name="NumberDisplay" x={props.x} y={props.y}>
      <BalanceContainer x={60} y={-31} />
      <StakeContainer x={gameConfig.resolution.width - 205} y={0} />
    </Container>
  )
}
